import * as React from 'react'
import type { JobStatus } from '../../reducers/jobs/jobs'
import { Sizes as ModalSizes } from '../../../stories/atoms/Modal/Modal'
import { Action, Category } from '../../../util/analytics-data-attributes/analyticsAttributes'

export const ADD_FILTER: 'ui/ADD_FILTER' = 'ui/ADD_FILTER'
export const HIDE_DIALOG: 'ui/HIDE_DIALOG' = 'ui/HIDE_DIALOG'
export const HIDE_FLASH_MESSAGE: 'ui/HIDE_FLASH_MESSAGE' = 'ui/HIDE_FLASH_MESSAGE'
export const HIDE_UPGRADES_FOR_JOB: 'ui/HIDE_UPGRADES_FOR_JOB' = 'ui/HIDE_UPGRADES_FOR_JOB'
export const REMOVE_FILTER: 'ui/REMOVE_FILTER' = 'ui/REMOVE_FILTER'
export const ROUTE_CHANGE_COMPLETED: 'ui/ROUTE_CHANGE_COMPLETED' = 'ui/ROUTE_CHANGE_COMPLETED'
export const ROUTE_CHANGE_FAILED: 'ui/ROUTE_CHANGE_FAILED' = 'ui/ROUTE_CHANGE_FAILED'
export const ROUTE_CHANGE_STARTED: 'ui/ROUTE_CHANGE_STARTED' = 'ui/ROUTE_CHANGE_STARTED'
export const SET_CREATION_STATUS_OF_DRAFT: 'ui/SET_CREATION_STATUS_OF_DRAFT' = 'ui/SET_CREATION_STATUS_OF_DRAFT'
export const SET_CURRENT_FILTER: 'ui/SET_CURRENT_FILTER' = 'ui/SET_CURRENT_FILTER'
export const SET_CURRENT_PAGE: 'ui/SET_CURRENT_PAGE' = 'ui/SET_CURRENT_PAGE'
export const SET_DEFAULT_LOGO_UPLOADING_STATUS: 'ui/SET_DEFAULT_LOGO_UPLOADING_STATUS' = 'ui/SET_DEFAULT_LOGO_UPLOADING_STATUS'
export const SET_DIALOG_PENDING_STATUS: 'ui/SET_DIALOG_PENDING_STATUS' = 'ui/SET_DIALOG_PENDING_STATUS'
export const SET_JOB_EDITING_STATUS: 'ui/SET_JOB_EDITING_STATUS' = 'ui/SET_JOB_EDITING_STATUS'
export const SET_JOB_ERROR: 'ui/SET_JOB_ERROR' = 'ui/SET_JOB_ERROR'
export const SET_JOB_SUSPENSION_OR_RESUMPTION_STATUS: 'ui/SET_JOB_SUSPENSION_OR_RESUMPTION_STATUS' = 'ui/SET_JOB_SUSPENSION_OR_RESUMPTION_STATUS'
export const SET_JOBS_FETCHING_ALL_STATUS: 'ui/SET_JOBS_FETCHING_ALL_STATUS' = 'ui/SET_JOBS_FETCHING_ALL_STATUS'
export const SET_LOGO_UPLOADING_STATUS: 'ui/SET_LOGO_UPLOADING_STATUS' = 'ui/SET_LOGO_UPLOADING_STATUS'
export const SET_SEARCH_QUERY: 'ui/SET_SEARCH_QUERY' = 'ui/SET_SEARCH_QUERY'
export const SET_SUBMISSION_STATUS_OF_DRAFT: 'ui/SET_SUBMISSION_STATUS_OF_DRAFT' = 'ui/SET_SUBMISSION_STATUS_OF_DRAFT'
export const SET_TOTAL_PAGE_COUNT: 'ui/SET_TOTAL_PAGE_COUNT' = 'ui/SET_TOTAL_PAGE_COUNT'
export const SET_USER_INFO_SUBMISSION_STATUS: 'ui/SET_USER_INFO_SUBMISSION_STATUS' = 'ui/SET_USER_INFO_SUBMISSION_STATUS'
export const SET_USER_SETTINGS_SUBMISSION_STATUS: 'ui/SET_USER_SETTINGS_SUBMISSION_STATUS' = 'ui/SET_USER_SETTINGS_SUBMISSION_STATUS'
export const SHOW_DIALOG: 'ui/SHOW_DIALOG' = 'ui/SHOW_DIALOG'
export const SHOW_UPGRADES_FOR_JOB: 'ui/SHOW_UPGRADES_FOR_JOB' = 'ui/SHOW_UPGRADES_FOR_JOB'
export const CLICK_CREATE_JOB: 'ui/CLICK_CREATE_JOB' = 'ui/CLICK_CREATE_JOB'
export const START_WAITING: 'ui/START_WAITING' = 'ui/START_WAITING'
export const STOP_WAITING: 'ui/STOP_WAITING' = 'ui/STOP_WAITING'
export const DISPLAY_PRODUCT_MODAL: 'ui/DISPLAY_PRODUCT_MODAL' = 'ui/DISPLAY_PRODUCT_MODAL'
export const HIDE_PRODUCT_MODAL: 'ui/HIDE_PRODUCT_MODAL' = 'ui/HIDE_PRODUCT_MODAL'
export const ADD_TOASTER: 'ui/ADD_TOASTER' = 'ui/ADD_TOASTER'
export const REMOVE_TOASTER: 'ui/REMOVE_TOASTER' = 'ui/REMOVE_TOASTER'
export const SET_SUGGESTED_SALARY_MINMAX: 'ui/SET_SUGGESTED_SALARY_MINMAX' = 'ui/SET_SUGGESTED_SALARY_MINMAX'

export type ModalAction = {
  label: string,
  url?: string,
  onClick?: () => void,
  dataAnalyticsAction?: Action,
  dataAnalyticsCategory?: Category,
  dataAnalyticsLabel?: string,
  icon?: any,
  iconHeight?: number,
}

export type Modal = {
  title: string,
  content: React.ReactNode,
  size?: ModalSizes,
  hideCloseButton?: boolean,
  primaryAction?: ModalAction,
  secondaryAction?: ModalAction,
}

export type SetJobErrorAction = {
  payload: {
    id: string,
    type: 'suspensionOrResumption',
    value: boolean,
  },
  type: typeof SET_JOB_ERROR,
}

export type HideDialogAction = {
  type: typeof HIDE_DIALOG,
}

type HideFlashMessageAction = {
  type: typeof HIDE_FLASH_MESSAGE,
}

export type ShowDialogAction = {
  payload: Modal,
  type: typeof SHOW_DIALOG,
}

export type SetCreationStatusOfDraftAction = {
  payload: boolean,
  type: typeof SET_CREATION_STATUS_OF_DRAFT,
}

export type SetSubmissionStatusOfDraftAction = {
  payload: boolean,
  type: typeof SET_SUBMISSION_STATUS_OF_DRAFT,
}

export type SetLogoUploadingStatusAction = {
  payload: boolean,
  type: typeof SET_LOGO_UPLOADING_STATUS,
}

export type SetDefaultLogoUploadingStatusAction = {
  payload: boolean,
  type: typeof SET_DEFAULT_LOGO_UPLOADING_STATUS,
}

export type SetJobSuspensionOrResumptionStatusAction = {
  payload: {
    id: string,
    isLoading: boolean,
  },
  type: typeof SET_JOB_SUSPENSION_OR_RESUMPTION_STATUS,
}

export type SetUserInfoSubmissionStatusAction = {
  payload: boolean,
  type: typeof SET_USER_INFO_SUBMISSION_STATUS,
}

export type SetUserSettingsSubmissionStatusAction = {
  payload: boolean,
  type: typeof SET_USER_SETTINGS_SUBMISSION_STATUS,
}

export type SetJobEditingStatusAction = {
  payload: boolean,
  type: typeof SET_JOB_EDITING_STATUS,
}

export type SetDialogPendingStatusAction = {
  payload: boolean,
  type: typeof SET_DIALOG_PENDING_STATUS,
}

export type RouteChangedAction = {
  payload: string,
  type: typeof ROUTE_CHANGE_STARTED | typeof ROUTE_CHANGE_COMPLETED | typeof ROUTE_CHANGE_FAILED,
}

export type SetCurrentFilterAction = {
  payload: JobStatus | undefined,
  type: typeof SET_CURRENT_FILTER,
}

export type AddFilterAction = {
  payload: JobStatus | undefined,
  type: typeof ADD_FILTER,
}

export type RemoveFilterAction = {
  payload: JobStatus | undefined,
  type: typeof REMOVE_FILTER,
}

export type SetSearchQueryAction = {
  payload: string | undefined,
  type: typeof SET_SEARCH_QUERY,
}

export type SetCurrentPageAction = {
  payload: number,
  type: typeof SET_CURRENT_PAGE,
}

export type SetTotalPageCountAction = {
  payload: number,
  type: typeof SET_TOTAL_PAGE_COUNT,
}

export type SetJobsFetchingAllStatusAction = {
  payload: boolean,
  type: typeof SET_JOBS_FETCHING_ALL_STATUS,
}

export type ShowUpgradesForJobAction = {
  payload: string,
  type: typeof SHOW_UPGRADES_FOR_JOB,
}

export type HideUpgradesForJobAction = {
  payload: null,
  type: typeof HIDE_UPGRADES_FOR_JOB,
}

export type ClickCreateJobAction = {
  payload: string
  type: typeof CLICK_CREATE_JOB
}

export type StartWaitingAction = {
  payload: string
  type: typeof START_WAITING
}

export type StopWaitingAction = {
  type: typeof STOP_WAITING
}

export type DisplayProductModalAction = {
  type: typeof DISPLAY_PRODUCT_MODAL
}

export type HideProductModalAction = {
  type: typeof HIDE_PRODUCT_MODAL
}

export type ToasterVariants = 'success' | 'error' | 'info'

export type AddToasterPayload = {
  id: string
  variant: ToasterVariants
  title: string
  description: string
}

export type AddToasterAction = {
  payload: AddToasterPayload,
  type: typeof ADD_TOASTER
}

export type RemoveToasterAction = {
  payload: string,
  type: typeof REMOVE_TOASTER
}

export type SetSuggestedSalaryMinMaxPayload = {
  min: number | undefined
  max: number | undefined
}

export type SetSuggestedSalaryMinMaxAction = {
  payload: SetSuggestedSalaryMinMaxPayload
  type: typeof SET_SUGGESTED_SALARY_MINMAX
}

export type UiActions =
  | AddFilterAction
  | HideDialogAction
  | HideFlashMessageAction
  | HideUpgradesForJobAction
  | RemoveFilterAction
  | RouteChangedAction
  | SetCreationStatusOfDraftAction
  | SetCurrentFilterAction
  | SetCurrentPageAction
  | SetDefaultLogoUploadingStatusAction
  | SetDialogPendingStatusAction
  | SetJobEditingStatusAction
  | SetJobErrorAction
  | SetJobsFetchingAllStatusAction
  | SetJobSuspensionOrResumptionStatusAction
  | SetLogoUploadingStatusAction
  | SetSearchQueryAction
  | SetSubmissionStatusOfDraftAction
  | SetTotalPageCountAction
  | SetUserInfoSubmissionStatusAction
  | SetUserSettingsSubmissionStatusAction
  | ShowDialogAction
  | ShowUpgradesForJobAction
  | ClickCreateJobAction
  | StartWaitingAction
  | StopWaitingAction
  | DisplayProductModalAction
  | HideProductModalAction
  | AddToasterAction
  | RemoveToasterAction
  | SetSuggestedSalaryMinMaxAction

export const setJobError = ({
  id,
  type,
  value,
}: SetJobErrorAction['payload']): SetJobErrorAction => ({
  payload: { id, type, value },
  type: SET_JOB_ERROR,
})

export const hideDialog = (): HideDialogAction => ({
  type: HIDE_DIALOG,
})

export const showDialog = (
  payload: ShowDialogAction['payload'],
): ShowDialogAction => ({
  payload,
  type: SHOW_DIALOG,
})

export const hideFlashMessage = () => ({
  type: HIDE_FLASH_MESSAGE,
})

export const setCreationStatusOfDraft = (
  status: SetCreationStatusOfDraftAction['payload'],
): SetCreationStatusOfDraftAction => ({
  payload: status,
  type: SET_CREATION_STATUS_OF_DRAFT,
})

export const setSubmissionStatusOfDraft = (
  status: SetSubmissionStatusOfDraftAction['payload'],
): SetSubmissionStatusOfDraftAction => ({
  payload: status,
  type: SET_SUBMISSION_STATUS_OF_DRAFT,
})

export const setLogoUploadingStatus = (
  status: SetLogoUploadingStatusAction['payload'],
): SetLogoUploadingStatusAction => ({
  payload: status,
  type: SET_LOGO_UPLOADING_STATUS,
})

export const setDefaultLogoUploadingStatus = (
  status: SetDefaultLogoUploadingStatusAction['payload'],
): SetDefaultLogoUploadingStatusAction => ({
  payload: status,
  type: SET_DEFAULT_LOGO_UPLOADING_STATUS,
})

export const setJobSuspensionOrResumptionStatus = ({
  id,
  isLoading,
}: SetJobSuspensionOrResumptionStatusAction['payload']
): SetJobSuspensionOrResumptionStatusAction => ({
  payload: { id, isLoading },
  type: SET_JOB_SUSPENSION_OR_RESUMPTION_STATUS,
})

export const setUserSettingsSubmissionStatus = (
  status: SetUserSettingsSubmissionStatusAction['payload'],
): SetUserSettingsSubmissionStatusAction => ({
  payload: status,
  type: SET_USER_SETTINGS_SUBMISSION_STATUS,
})

export const setUserInfoSubmissionStatus = (
  status: SetUserInfoSubmissionStatusAction['payload'],
): SetUserInfoSubmissionStatusAction => ({
  payload: status,
  type: SET_USER_INFO_SUBMISSION_STATUS,
})

export const setJobEditingStatus = (
  isLoading: SetJobEditingStatusAction['payload'],
): SetJobEditingStatusAction => ({
  payload: isLoading,
  type: SET_JOB_EDITING_STATUS,
})

export const setDialogPendingStatus = (
  isPending: SetDialogPendingStatusAction['payload'],
): SetDialogPendingStatusAction => ({
  payload: isPending,
  type: SET_DIALOG_PENDING_STATUS,
})

export const sendRouteChangeStarted = (
  url: RouteChangedAction['payload'],
): RouteChangedAction => ({
  payload: url,
  type: ROUTE_CHANGE_STARTED,
})

export const sendRouteChangeCompleted = (
  url: RouteChangedAction['payload'],
): RouteChangedAction => ({
  payload: url,
  type: ROUTE_CHANGE_COMPLETED,
})

export const sendRouteChangeFailed = (
  url: RouteChangedAction['payload'],
): RouteChangedAction => ({
  payload: url,
  type: ROUTE_CHANGE_FAILED,
})

export const setCurrentFilter = (
  status: SetCurrentFilterAction['payload'],
): SetCurrentFilterAction => ({
  payload: status,
  type: SET_CURRENT_FILTER,
})

export const addFilter = (status: AddFilterAction['payload']): AddFilterAction => ({
  payload: status,
  type: ADD_FILTER,
})

export const removeFilter = (
  status: RemoveFilterAction['payload'],
): RemoveFilterAction => ({
  payload: status,
  type: REMOVE_FILTER,
})

export const setSearchQuery = (query: SetSearchQueryAction['payload']) => ({
  payload: query,
  type: SET_SEARCH_QUERY,
})

export const setCurrentPage = (
  pageNumber: SetCurrentPageAction['payload'],
): SetCurrentPageAction => ({
  payload: pageNumber,
  type: SET_CURRENT_PAGE,
})

export const setTotalPageCount = (
  pageNumber: SetTotalPageCountAction['payload'],
): SetTotalPageCountAction => ({
  payload: pageNumber,
  type: SET_TOTAL_PAGE_COUNT,
})

export const setJobsFetchingAllStatus = (
  status: SetJobsFetchingAllStatusAction['payload'],
): SetJobsFetchingAllStatusAction => ({
  payload: status,
  type: SET_JOBS_FETCHING_ALL_STATUS,
})

export const showUpgradesForJob = (jobId: string): ShowUpgradesForJobAction => ({
  type: SHOW_UPGRADES_FOR_JOB,
  payload: jobId,
})

export const hideUpgradesForJob = (): HideUpgradesForJobAction => ({
  type: HIDE_UPGRADES_FOR_JOB,
  payload: null,
})

export const clickCreateJob = (id: string): ClickCreateJobAction => ({
  payload: id,
  type: CLICK_CREATE_JOB,
})

export const startWaiting = (id: string): StartWaitingAction => ({
  payload: id,
  type: START_WAITING
})

export const stopWaiting = (): StopWaitingAction => ({
  type: STOP_WAITING
})

export const displayProductModal = (): DisplayProductModalAction => ({
  type: DISPLAY_PRODUCT_MODAL
})

export const hideProductModal = (): HideProductModalAction => ({
  type: HIDE_PRODUCT_MODAL
})

export const addToaster = (payload: AddToasterPayload): AddToasterAction => ({
  payload,
  type: ADD_TOASTER
})

export const removeToaster = (id: string) => ({
  payload: id,
  type: REMOVE_TOASTER
})

export const setSuggestedSalaryMinMax = (payload: SetSuggestedSalaryMinMaxPayload): SetSuggestedSalaryMinMaxAction => ({
  payload,
  type: SET_SUGGESTED_SALARY_MINMAX
})

export const clearSuggestedSalaryMinMax = (): SetSuggestedSalaryMinMaxAction => ({
  payload: { min: null, max: null },
  type: SET_SUGGESTED_SALARY_MINMAX
})
